import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import store from 'store/index';
import Util from 'utility';
import { __ } from 'locale';

function ProfileMenu() {
    const data = useSelector(state => state);
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!isOpen) return;
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    const { user } = data;
    if (!user || !data.globals.newsDates) return null;

    const profileId = Util.getActiveProfileId();
    const hidePanel = () => setIsOpen(false);

    let avatar = null;
    if (profileId > 0) {
        const profile = data.globals.profiles[profileId];
        avatar = <img src={`https://www.zofapp.cz/data/zof/profile/${profile.picture}?r=${Math.random() * 10000000}`} className="block w-8 h-8 rounded-[40px] border-l border-[#ddd]" />;
    }

    const linkClass = 'whitespace-nowrap block m-0 py-3 pl-4 pr-6 text-[#444] no-underline hover:text-[#26AA52]';
    const iconClass = 'inline-block w-[1.5em] text-[#444] text-[0.8em]';

    let debugButton = null;
    if (user.id == 1485 || user.id == 90) {
        debugButton = (
            <a onClick={() => { hidePanel(); console.log(store.getState()); }} className={linkClass}>
                <span className={iconClass}><i className="fa fa-bug"></i></span> Debug
            </a>
        );
    }

    return (
        <div className="relative text-[#777]" ref={containerRef}>
            <label onClick={() => setIsOpen(!isOpen)} className="cursor-pointer select-none flex items-center bg-[#efefef] rounded-[40px]">
                {avatar}
            </label>
            {isOpen && (
                <div className="absolute right-0 z-10 rounded overflow-hidden bg-white shadow-[0_8px_48px_rgba(0,0,0,0.2)] [animation:slideUp_0.15s_ease-out]" style={{ top: 'calc(100% + 2px)' }}>
                    <Link onClick={hidePanel} to={`/user/edit/${profileId}`} className={linkClass}>
                        <span className={iconClass}><i className="fa fa-cog"></i></span> {__('Nastavení')}
                    </Link>
                    {debugButton}
                    <a href="https://www.zofapp.cz/user/logout" className={linkClass}>
                        <span className={iconClass}><i className="fa fa-sign-out-alt"></i></span> {__('Odhlásit se')}
                    </a>
                </div>
            )}
        </div>
    );
}

export default ProfileMenu;
